export enum AlertConditionsEnum {
	Meets = 'Meets',
	Exceeds = 'Exceeds',
	MeetsOrExceeds = 'Meets or Exceeds',
	DropsBelow = 'Drops Below',
	MeetsOrDropsBelow = 'Meets or Drops Below',
	PercentChangeFromPreviousPeriod = 'Percent Change from Previous Period',
	PercentChangeFromPreviousPeriodPlusMinus = 'Percent Change from Previous Period (+/-)',
}
